'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/productListCarousel'));
    processInclude(require('./components/bannerCarousel'));
    processInclude(require('./components/sortModal'));
    processInclude(require('./page/search/search'));
});
